<template>
  <v-card class="global-card">
    <v-card-title class="d-flex justify-space-between">
      <h3>Interactions</h3>

      <v-text-field
        v-if="interactions.length > 0"
        class="ma-2"
        v-model="searchEntry"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        outlined
        rounded
        dense
        :disabled="loading"
      ></v-text-field>
    </v-card-title>
    <v-card-text class="interactions">
      <v-data-table
        :headers="headers"
        :items="interactions"
        :mobile-breakpoint="0"
        :loading="loading"
        class="table"
        v-if="interactions.length > 0"
      >
        <template v-slot:item="interaction">
          <tr>
            <td class="text-center">
              <v-icon
                title="Out Bound"
                v-if="interaction.item.out === true"
                color="success"
                >mdi-phone-forward</v-icon
              >
              <v-icon title="In Bound" v-else color="error"
                >mdi-phone-missed</v-icon
              >
            </td>
            <td class="text-center">
              {{ interaction.item.start ? interaction.item.start.date : "---" }}
            </td>
            <td class="text-center">
              {{ interaction.item.agent ? interaction.item.agent.name : "---" }}
            </td>
            <td class="text-center">
              {{
                interaction.item.classification
                  ? interaction.item.classification.name
                  : "---"
              }}
            </td>
            <td class="text-center m-b-0">
              <read-more
                more-str=""
                :text="interaction.item.notes || '---'"
                :max-chars="20"
                class="mb-0"
              ></read-more>
            </td>
            <td class="text-center">
              <i
                v-if="interaction.item.has_created_tasks"
                class="icon-active primary-icon"
              ></i>
              <div v-else class="empty-circle"></div>
            </td>
            <td class="table__cell pa-0 text-center">
              <v-btn
                small
                rounded
                class="px-0"
                primary
                color="white"
                @click="interactionShow(interaction.item)"
              >
                <!-- title="Details"
                  color="black"
                  @click="interactionShow(interaction.item)" -->
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <h2 class="text-center py-10" v-else>No Interactions yet.</h2>
    </v-card-text>
    <v-dialog v-model="dialog" width="500">
      <v-card class="global-card pa-5">
        <v-card-title class="font-bold pa-0" primary-title>
          <h3>
            <span>Interaction Details</span>
          </h3>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <p class="mb-0 pb-0">{{ `#` + interactionData.serial }}</p>
        <h5 class="px-4 py-4">
          {{ interactionData.start ? interactionData.start.date : "--" }}
        </h5>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <span>Mobile Number :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{ interactionData.mobile }}</span>
            </v-col>
            <v-col cols="4">
              <span>Action :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                interactionData.action ? interactionData.action.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Classification :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                interactionData.classification
                  ? interactionData.classification.name
                  : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Agent :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                interactionData.agent ? interactionData.agent.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Channel :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                interactionData.channel ? interactionData.channel.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Type :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark" v-if="interactionData.out === true"
                >Out Bound</span
              >
              <span class="color-dark" v-else>In Bound</span>
            </v-col>
            <v-col cols="4">
              <span>Notes :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                interactionData.notes || "---"
              }}</span>
            </v-col>
            <v-col cols="3" class="mx-auto">
              <v-btn
                class="button btn-height--1 mt-8 mx-1"
                color="success"
                rounded
                @click="dialog = false"
              >
                <span class="mx-2">Ok</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ShowData } from "@/helpers/apiMethods";

import TableHeaders from "@/helpers/TableHeaders";

export default {
  data() {
    return {
      headers: [],
      interactionData: [],
      dialog: false,
      // loadingInteraction: false,
      currentInteractionSerial: null,
      searchEntry: "",
      loading: false
    };
  },
  props: {
    interactions: {
      type: Array,
      default: () => {}
    }
  },
  created() {
    this.createTableHeaders();
  },
  watch: {
    searchEntry: {
      handler() {
        this.getInteractionData();
      }
    }
  },
  methods: {
    createTableHeaders() {
      const headersList = [
        "Call",
        "Date",
        "Agent",
        "Classification",
        "Notes",
        "Tasks",
        "Details"
      ];
      this.headers = TableHeaders(headersList);
    },
    interactionShow({ serial }) {
      // this.loadingInteraction = true;
      this.currentInteractionSerial = serial;
      this.getInteractionData();
      setTimeout(() => {
        this.dialog = true;
      }, 500);
    },
    getInteractionData() {
      this.loading = true;

      ShowData({
        reqName: `crm/interactions`,
        id: this.currentInteractionSerial,
        query: {
          note_like: this.searchEntry
        }
      })
        .then(res => {
          // this.loadingInteraction = false;
          const { interaction } = res.data;
          this.interactionData = interaction;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
